import axios from 'axios'
import { getBackendUrls } from '../../../config/backendEnv'

const urlCriarEmail = () => {
  const api = String(getBackendUrls().oikos || '')
  return api.replace(/_oikos_api\.php.*$/, '_criar_email_corporativo.php')
}

export const criarEmailCorporativo = async (pfId) => {
  const response = await axios.post(urlCriarEmail(), { pf_id: Number(pfId) })
  return response.data || {}
}
